/*
 * MMM · Galerie ordinateur en cadre vertical (≥ 1000 px), commune à la Croix Protectrice et au Jardin d'Hiver.
 * Sortie de assets/mmm-croix.js le 01/10/2026 (RDV Mathilde du 01/10). CSS et marqueur : snippets/mmm-galerie-v.liquid.
 * Ne fait rien sur une page sans le marqueur [data-mmm-galerie-v].
 */
(() => {
  if (window.mmmGalerieV) return;
  window.mmmGalerieV = true;
  // Galerie ordinateur (≥ 1000 px) : cadre vertical (CSS .mmm-galerie-v dans snippets/mmm-galerie-v.liquid).
  //    - 02/10 : le cadre a le format des photos (2:3) et la hauteur visible de l'écran ; vignettes en colonne à sa droite ; la grille
  //      produit donne à la galerie exactement photo + vignettes (--mmm-col-galerie), la colonne d'achat prend le reste ;
  //    - le carrousel du thème reste la seule source de sélection : chaque « carousel:select » (vignette, variante, recalage,
  //      nos flèches) fait défiler le cadre à la verticale ; la photo visible allume sa vignette (.mmm-actif) ;
  //    - la barre de vignettes et les flèches restent dans la partie du cadre visible à l'écran.
  const ORDI = window.matchMedia('(min-width: 1000px)');
  const galerie = () => document.querySelector('product-gallery');
  const car = () => { const g = galerie(); return g && g.querySelector('.product-gallery__carousel'); };
  const cellules = () => { const c = car(); return c ? [...c.querySelectorAll('.product-gallery__media')] : []; };
  const visibles = () => cellules().filter((x) => !x.hidden);
  const indexCourant = () => {
    const c = car(); const v = visibles(); if (!c || !v.length) return 0;
    let best = 0, dist = Infinity;
    v.forEach((x, i) => { const d = Math.abs(x.offsetTop - c.scrollTop); if (d < dist) { dist = d; best = i; } });
    return best;
  };
  const allumer = () => {
    const g = galerie(); if (!g) return;
    const x = visibles()[indexCourant()]; const id = x && x.getAttribute('data-media-id');
    g.querySelectorAll('.product-gallery__thumbnail').forEach((t) => t.classList.toggle('mmm-actif', t.getAttribute('data-media-id') === id));
    const t = g.querySelector('.product-gallery__thumbnail.mmm-actif'); const bar = t && t.parentElement;
    if (t && bar && bar.scrollHeight > bar.clientHeight) bar.scrollTop += (t.getBoundingClientRect().top - bar.getBoundingClientRect().top) - (bar.clientHeight - t.offsetHeight) / 2;
  };
  let visee = null;  // dernière photo demandée : un redimensionnement pendant le défilement doux recale sur elle, pas sur l'ancienne
  const allerA = (cell, doux) => { const c = car(); if (c && cell) { visee = { cell, t: Date.now() }; c.scrollTo({ top: cell.offsetTop, behavior: doux ? 'smooth' : 'auto' }); } };
  // Format des photos : le plus fréquent dans la galerie (toutes en 2:3 sur le Jardin d'Hiver ; 21 sur 25 dans la croix).
  const formatDe = (img) => { const w = +img.getAttribute('width') || img.naturalWidth, h = +img.getAttribute('height') || img.naturalHeight; return w && h ? w / h : 0; };
  const formatDominant = () => {
    const compte = new Map();
    cellules().forEach((x) => { const img = x.querySelector(':scope > img'); const r = img && formatDe(img); if (r) { const k = r.toFixed(2); compte.set(k, (compte.get(k) || 0) + 1); } });
    let best = null, n = 0; compte.forEach((v, k) => { if (v > n) { n = v; best = +k; } });
    return best || 2 / 3;
  };
  const cadrer = () => {
    const g = galerie(); const liste = g && g.querySelector('.product-gallery__image-list');
    if (!g || !liste) return;
    const grille = g.parentElement;
    if (!ORDI.matches) {
      g.classList.remove('mmm-galerie-v', 'mmm-entete-dessus'); g.style.marginTop = '';
      ['--mmm-photo-h', '--mmm-photo-l', '--mmm-vignette-l', '--mmm-galerie-bord', '--mmm-rail-haut', '--mmm-colle-haut'].forEach((v) => g.style.removeProperty(v));
      if (grille) grille.style.removeProperty('--mmm-col-galerie');
      return;
    }
    // Photo en cours, à recaler après le changement de hauteur (sinon le cadre montre le bas de la photo précédente).
    const garder = g.classList.contains('mmm-galerie-v') ? indexCourant() : null;
    g.classList.add('mmm-galerie-v');
    // La galerie remonte jusque sous l'en-tête (sous la barre d'annonce) ; le fil d'Ariane passe au-dessus de la colonne d'achat.
    const annonce = document.querySelector('.shopify-section--announcement-bar, [id$="__announcement-bar"]');
    const plafond = annonce ? annonce.getBoundingClientRect().bottom + window.scrollY : 0;
    const mt = parseFloat(g.style.marginTop) || 0;
    const naturel = g.getBoundingClientRect().top + window.scrollY - mt;
    g.style.marginTop = -Math.max(0, Math.round(naturel - plafond)) + 'px';
    // Dimensions : ne dépendent que de la fenêtre et de la grille (jamais de la colonne d'achat, qui change de largeur en retour).
    const rg = grille.getBoundingClientRect();
    const bord = Math.max(0, Math.round(rg.left));  // bord gauche de la grille produit
    const R = formatDominant();
    const visible = Math.max(420, Math.round(window.innerHeight - plafond));  // du bandeau d'annonce au bas de la fenêtre
    const vignette = Math.max(64, Math.min(96, Math.round(visible * 0.09)));
    const rail = 14 + vignette + 8;  // écart, vignettes (anneau de sélection compris), marge
    const plafondL = bord + rg.width * 0.58 - rail;  // la galerie ne prend jamais plus de ~58 % de la grille
    const photoL = Math.round(Math.min(visible * R, plafondL));
    const photoH = Math.round(photoL / R);
    g.style.setProperty('--mmm-galerie-bord', bord + 'px');
    g.style.setProperty('--mmm-colle-haut', Math.round(plafond) + 'px');  // galerie collante : calée sous le bandeau d'annonce
    g.style.setProperty('--mmm-photo-l', photoL + 'px');
    g.style.setProperty('--mmm-photo-h', photoH + 'px');
    g.style.setProperty('--mmm-vignette-l', vignette + 'px');
    const tete = document.querySelector('.shopify-section--header');  // la colonne de vignettes démarre sous l'en-tête (sinon elle passe sous le logo)
    g.style.setProperty('--mmm-rail-haut', (tete ? tete.offsetHeight + 8 : 0) + 'px');
    grille.style.setProperty('--mmm-col-galerie', Math.max(200, photoL + rail - bord) + 'px');
    // Photo d'un autre format que la galerie : entière sur le gris chaud plutôt que rognée.
    cellules().forEach((x) => { const img = x.querySelector(':scope > img'); const r = img && formatDe(img); x.classList.toggle('mmm-format-autre', !!r && Math.abs(r - R) / R > 0.04); });
    const fil = document.querySelector('.breadcrumb'); const info = document.querySelector('.product-info');
    if (fil && info) document.documentElement.style.setProperty('--mmm-fil-x', Math.max(0, Math.round(info.getBoundingClientRect().left - fil.getBoundingClientRect().left)) + 'px');
    if (garder !== null) {
      const x = visee && Date.now() - visee.t < 1500 && !visee.cell.hidden ? visee.cell : visibles()[garder];
      const c = car(); if (x && c && Math.abs(c.scrollTop - x.offsetTop) > 1) c.scrollTo({ top: x.offsetTop, behavior: x === (visee && visee.cell) ? 'smooth' : 'auto' });
    }
    placer();
  };
  const placer = () => {
    const g = galerie(); const liste = g && g.querySelector('.product-gallery__image-list');
    if (!g || !liste || !ORDI.matches) return;
    const r = liste.getBoundingClientRect();
    // En-tête « sur la photo » seulement en haut de page : dès qu'on descend, le texte de la colonne d'achat passerait sous l'en-tête
    // transparent (retour de Paul du 30/09) ; il redevient blanc.
    const tete = document.querySelector('.shopify-section--header');
    const basTete = tete ? tete.getBoundingClientRect().bottom : 0;
    g.classList.toggle('mmm-entete-dessus', window.scrollY < 24 && r.bottom > basTete + 4 && r.top < basTete);  // lu par html:has(...) : le thème réécrit les classes de <html>
  };
  const poserGalerie = () => {
    const g = galerie(); const liste = g && g.querySelector('.product-gallery__image-list'); const c = car();
    if (!g || !liste || !c || g.dataset.mmmGalerie) return;
    g.dataset.mmmGalerie = '1';
    c.addEventListener('carousel:select', (e) => { if (ORDI.matches && e.detail && e.detail.cell) allerA(e.detail.cell, true); });
    let att = false;
    c.addEventListener('scroll', () => { if (att) return; att = true; requestAnimationFrame(() => { att = false; if (ORDI.matches) allumer(); }); }, { passive: true });
    [['prec', -1, '‹', 'Photo précédente'], ['suiv', 1, '›', 'Photo suivante']].forEach(([cle, sens, signe, nom]) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'mmm-galerie-fleche mmm-galerie-fleche--' + cle; b.textContent = signe; b.setAttribute('aria-label', nom);
      b.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const v = visibles(); if (!v.length) return;
        allerA(v[(indexCourant() + sens + v.length) % v.length], true);
      });
      liste.appendChild(b);
    });
    // Molette / pavé au-dessus de la photo : une photo par geste, jamais la page (l'accrochage « mandatory » ramenait un petit
    // cran de molette sur la même photo). Hors de la photo, rien n'est intercepté : la page défile normalement.
    let cumul = 0, bloque = 0;
    liste.addEventListener('wheel', (e) => {
      if (!ORDI.matches || Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      // 02/10 : la galerie reste à l'écran pendant le défilement ; arrivée à la dernière photo (ou à la première en remontant), la
      // molette rend la main à la page, sinon la page ne descendrait plus quand la souris est sur la photo.
      const vv = visibles(), ii = indexCourant();
      if ((e.deltaY > 0 && ii >= vv.length - 1) || (e.deltaY < 0 && ii <= 0)) { cumul = 0; return; }
      e.preventDefault();
      const maintenant = Date.now();
      if (maintenant < bloque) return;
      cumul += e.deltaY;
      if (Math.abs(cumul) < 40) return;
      const v = visibles(); if (!v.length) return;
      const i = indexCourant(), j = Math.min(v.length - 1, Math.max(0, i + (cumul > 0 ? 1 : -1)));
      cumul = 0; bloque = maintenant + 550;
      if (j !== i) allerA(v[j], true);
    }, { passive: false });
    // Colonne de vignettes : signaler qu'il reste des photos à faire défiler (fondu + flèches du côté concerné).
    const liste2 = g.querySelector('.product-gallery__thumbnail-list');
    const defil = liste2 && liste2.querySelector('.product-gallery__thumbnail-scroller');
    if (liste2 && defil) {
      const majBords = () => {
        // Colonne verticale depuis le 02/10 : « gauche » = plus haut, « droite » = plus bas.
        const reste = defil.scrollHeight - defil.clientHeight - defil.scrollTop;
        liste2.classList.toggle('mmm-plus-gauche', ORDI.matches && defil.scrollTop > 4);
        liste2.classList.toggle('mmm-plus-droite', ORDI.matches && reste > 4);
      };
      [['prec', -1, '‹', 'Vignettes précédentes'], ['suiv', 1, '›', 'Vignettes suivantes']].forEach(([cle, sens, signe, nom]) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'mmm-vignettes-fleche mmm-vignettes-fleche--' + cle; b.textContent = signe; b.setAttribute('aria-label', nom);
        b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); defil.scrollBy({ top: sens * defil.clientHeight * 0.8, behavior: 'smooth' }); });
        liste2.appendChild(b);
      });
      defil.addEventListener('scroll', majBords, { passive: true });
      window.addEventListener('resize', majBords, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(majBords).observe(defil);
      majBords();
    }
    let attP = false;
    const planifier = () => { if (attP) return; attP = true; requestAnimationFrame(() => { attP = false; placer(); }); };
    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', () => { cadrer(); allumer(); }, { passive: true });
    if (window.ResizeObserver) { const info = document.querySelector('.product-info'); if (info) new ResizeObserver(() => cadrer()).observe(info); }
    cadrer();
    // Départ : la photo de la variante affichée
    const init = cellules().find((x) => x.classList.contains('is-initial'));
    if (ORDI.matches && init) allerA(init, false);
    allumer();
  };
  const initPage = () => { if (!document.querySelector('[data-mmm-galerie-v]')) return; poserGalerie(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage); else initPage();
  window.addEventListener('load', initPage);
})();
